import { formatPurchasePlanningNumber } from '../../../lib/purchasePlanningHelpers';

export function PurchaseRoundingSummaryBar({ summary }) {
  if (!summary) return null;

  const cards = [
    { label: 'SKUs in scope', value: formatPurchasePlanningNumber(summary.skuCount) },
    { label: 'OTB units', value: formatPurchasePlanningNumber(summary.totalOtbUnits) },
    { label: 'Base buy units', value: formatPurchasePlanningNumber(summary.totalBaseBuyUnits) },
    { label: 'Adjusted rounded units', value: formatPurchasePlanningNumber(summary.totalAdjustedRoundedUnits) },
    { label: 'Rounding delta', value: formatPurchasePlanningNumber(summary.totalRoundingDelta) },
    { label: 'Exceptions', value: formatPurchasePlanningNumber(summary.exceptionCount) },
  ];

  return (
    <div className="mt-4 grid gap-2 md:grid-cols-2 xl:grid-cols-6">
      {cards.map(card => (
        <div key={card.label} className="rounded-md border border-gray-200 bg-white px-3 py-2">
          <p className="text-[11px] uppercase tracking-[0.12em] text-gray-500">{card.label}</p>
          <p className="mt-1 text-lg font-semibold text-gray-900">{card.value}</p>
        </div>
      ))}
    </div>
  );
}
